package com.evoapps.evoshift.ui.roster

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.ui.Cream
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.util.monthName
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.GoldButton
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.top_bar_create_roster
import evoshift.composeapp.generated.resources.top_bar_no_roster
import kotlinx.datetime.YearMonth
import kotlinx.datetime.number
import org.jetbrains.compose.resources.stringResource

/**
 * SH-89: the top bar's month has no roster at this workplace (yet). The bar stays, so the arrows
 * lead on to the next month; [onCreate] (those who build rosters) starts one.
 */
@Composable
fun NoRosterForMonth(
    month: YearMonth,
    onBack: () -> Unit,
    title: String? = null,
    onCreate: (() -> Unit)? = null,
    /** Instead of "<month>: no roster yet." (e.g. no availability request for the month). */
    message: String? = null,
    showWorkplace: Boolean = true
) {
    Scaffold(
        containerColor = Cream,
        topBar = { EvoTopBar(title = title, onBack = onBack, showWorkplace = showWorkplace, showMonth = true) }
    ) { padding ->
        Column(
            modifier = Modifier.fillMaxSize().padding(padding).padding(32.dp),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(16.dp, Alignment.CenterVertically)
        ) {
            Text(
                message ?: stringResource(Res.string.top_bar_no_roster, "${monthName(month.month.number)} ${month.year}"),
                style = MaterialTheme.typography.titleMedium,
                color = DeepNavy,
                textAlign = TextAlign.Center
            )
            if (onCreate != null) {
                GoldButton(text = stringResource(Res.string.top_bar_create_roster), onClick = onCreate)
            }
        }
    }
}
